module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-296.9afb5ba.woff2";